var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"dropdown_arrow","d":"M17 10l-5 4.614L7 10z"})),React.createElement("use",{"fill":"#00121A","fillRule":"evenodd","xlinkHref":"#dropdown_arrow","key":1})]);
}

DropdownArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
